import React from 'react';
import { Image } from 'lucide-react';

const AlbumBrowserSection = ({ albums, selectedAlbumId, onSelect }) => {
  if (!albums.length) {
    return null;
  }

  return (
    <details className="group" open>
      <summary className="cursor-pointer text-sm text-gray-600 hover:text-gray-800 flex items-center space-x-2 py-2 border-t border-gray-200 pt-4">
        <span>Browse all {albums.length} albums</span>
        <svg className="w-4 h-4 transition-transform group-open:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </summary>

      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 max-h-64 overflow-y-auto">
        {albums.map(album => {
          const isSelected = selectedAlbumId === album.id;

          return (
            <div
              key={album.id}
              onClick={() => onSelect(album.id)}
              className={`relative cursor-pointer rounded-lg overflow-hidden border transition-all duration-200 hover:scale-105 ${
                isSelected
                  ? 'border-blue-500 ring-1 ring-blue-200'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="aspect-square relative bg-gray-100">
                {album.thumbnailUrl ? (
                  <img
                    src={album.thumbnailUrl}
                    alt={album.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik00MCAzMkw1MCA0Mkw2MCAzMkw3MCA0Mkw4MCAzMlY2OEgyMFYzMkg0MFoiIGZpbGw9IiNEMUQ1REIiLz4KPGNpcmNsZSBjeD0iMzUiIGN5PSI0MiIgcj0iNSIgZmlsbD0iI0QxRDVEQiIvPgo8L3N2Zz4=';
                    }}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <Image className="h-6 w-6 text-gray-400" />
                  </div>
                )}

                {isSelected && (
                  <div className="absolute top-1 right-1 bg-blue-500 text-white rounded-full p-1">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>

              <div className="p-2 bg-white">
                <p className="text-xs font-medium text-gray-900 truncate" title={album.title}>
                  {album.title || 'Untitled Album'}
                </p>
                <p className="text-xs text-gray-500">
                  {album.photoCount} photo{album.photoCount !== 1 ? 's' : ''}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </details>
  );
};

export default AlbumBrowserSection;
